module.exports = __webpack_public_path__ + "media/img/frontend_application/navicon/white-fav-icon-7b5172e8f8c9b4af04230100484704ed.svg";